(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   pages - product - PRODUCT DETAIL
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   setup markup
 *   products flyout
 *   helper functions
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
		if(isProductDetailPage()) {

			/* setup markup */
			/* ************ */

			setupMarkup();

			/* product variations dropdown */
			/* *************************** */

			$(document).on('click', '.selected-variant', function() {
				$(this).toggleClass('active');
				$('.field--name-quantity').toggleClass('opacity-js');
				$('.grouped-products-view').toggleClass('visible');
				$('html').toggleClass('js-selectedvariantdropdown-open');
			});
			// -> close by clicking somewhere on the page:
			//    commented out, because the list can be really long and users might
			//    touch scroll from outside the dropdown (which whould close it)
			/* $(document).on('click touchstart', function(event) {
				if($('html').hasClass('js-selectedvariantdropdown-open')) {
					const target = $(event.target);
					if(target.closest('.variant-dropdown').length <= 0 && target.closest('.grouped-products-view').length <= 0) {
						$('.selected-variant').removeClass('active');
						$('.field--name-quantity').removeClass('opacity-js');
						$('.grouped-products-view').removeClass('visible');
						$('html').removeClass('js-selectedvariantdropdown-open');
					}
				}
			}); */
			// -> close with escape:
			$(document).on('keydown.selectedVariant', function(event) {
				if(event.keyCode === 27) {
					if($('html').hasClass('js-selectedvariantdropdown-open')) {
						$('.selected-variant').removeClass('active');
						$('.field--name-quantity').removeClass('opacity-js');
						$('.grouped-products-view').removeClass('visible');
						$('html').removeClass('js-selectedvariantdropdown-open');
					}
				}
			});

			/* flyout */
			/* ****** */

			setupFlyout();

		}
	});




/** --------------------------------------------------
    #setup markup
    -------------------------------------------------- */

	function setupMarkup() {

		// move the 'in stock' label to inside cart form:
		if($('.cart-wrapper .max-quantity')[0]) {
			$('.cart-wrapper .in-stock-wrapper').insertAfter('.max-quantity');
		}
		$('body').addClass('js-stocklabel-processed');
		
		// add class to image block for decoration if product promotion does not exist:
		if(!($('.custom-promo-banner-link')[0])) {
			$('.field-name-field-product-photo').addClass('decoration');
		}
		
		// add wrappers:
		$('.table-add-to-cart-form').wrapInner($("<div class='flyout-inner-wrapper-js'></div>"));
		$('.table-add-to-cart-form .fancy-button').wrap("<div class='flyout-button-wrapper-js'></div>");

	} /* setupMarkup */




/** --------------------------------------------------
    #products flyout
	-------------------------------------------------- */
	
	// Polyfill to let URLSearchParams work in IE11 and lower
	(function (w) {

		w.URLSearchParams = w.URLSearchParams || function (searchString) {
			var self = this;
			self.searchString = searchString;
			self.get = function (name) {
				var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
				if (results == null) {
					return null;
				}
				else {
					return decodeURI(results[1]) || 0;
				}
			};
		};
	
	})(window);

	function setupFlyout() {

		if ($('body').hasClass('logged-in')) {

			const url_params = new URLSearchParams(window.location.search);

			if (url_params.get('open') == 1) {
				$('body').addClass('flyout-active-product');
				// Remove 'open' parameter from add-to-cart forms, to prevent showing fly-out after adding products to cart
				$('form[data-drupal-selector="table-add-to-cart-form"]').each(function() {
					let $this = $(this);
					let url_parts = $this.attr('action').split('?');
					if (url_parts.length >= 2) {
						const prefix = 'open=';
						let params = url_parts[1].split(/[&;]/g);
						for (let i = params.length; i-- > 0;) {
							if (params[i].lastIndexOf(prefix, 0) !== -1) {
								params.splice(i, 1);
							}
						}
						$this.attr('action' , url_parts[0] + (params.length > 0 ? '?' + params.join('&') : ''));
					}
				});
			}
		}
		
		/* open */
		/* **** */

		$(document).on('click', '.register-product-flyout', function() {
			$('body').addClass('flyout-active-product');
		});

		/* close */
		/* ***** */

		// close-button:
		$('.table-add-to-cart-form .flyout-close-button, .overlay').on('click', function(event) {
			event.preventDefault();
			$('body').removeClass('flyout-active-product');
		});

		// close via ESC-key:
		$(document).on('keydown.productFlyout', function(event) {
			if(event.keyCode === 27) {
				if($('body').hasClass('flyout-active-product')) {
					$('body').removeClass('flyout-active-product');
				}
			}
		});

		/* scroll */
		/* ****** */

		// scroll with gradients:

		var flyout_height = $('.table-add-to-cart-form .list-outer-wrapper').height();
		var flyout_content_height = $('.table-add-to-cart-form .list').height();
		if(flyout_height < flyout_content_height) {
			$('.table-add-to-cart-form .list-outer-wrapper').addClass('is-overflow'); // When there is an overflow add this class
		}

		// -> scroll event:
		$('.table-add-to-cart-form .list-outer-wrapper').scroll(function(e) {
			var element = e.target;
			if (element.scrollHeight - element.scrollTop === element.clientHeight) {
				$(this).addClass('is-down'); // -> when scrolling down
			}
			if (element.scrollTop === 0) {
				$(this).removeClass('is-down'); //-> when scrolling up
			}
		});

		/* add to cart */
		/* *********** */

		// prevent "add to cart" if nothing is selected:

		// -> add a warning to the html:
		const $warningDiv = $(`<div class="product-flyout-notice product-flyout-notice--valuenotok"><div class="product-flyout-notice__inner">${Drupal.t('To continue, please select one or more products.')}</div></div>`);
		$('.flyout-button').prepend($warningDiv);

		// -> button click:
		$(document).on('click.slideOutAddToCart', '.flyout-button-wrapper-js .form-submit', function(event) {
			event.preventDefault();

			let canSubmitForm = false;
			let totalNr = 0;
			
			// -> check all of the number inputs and see if the total is more than 0:
			$('.table-add-to-cart-form .list-wrapper').find('.item').each(function(index, element) {
				const $numberInput = $(element).find('input[type="number"]');
				if($numberInput.length > 0) {
					let inputNr = 0;
					const inputValue = $numberInput.val();
					if(duo.Utils.isNumber(inputValue)) {
						inputNr = parseFloat(inputValue);
					}
					if(inputNr !== 0) {
						totalNr = totalNr + inputNr;
					}
				}
			});
			if(totalNr > 0) {
				canSubmitForm = true;
			}

			// -> submit the form if ok, else, show a warning:
			if(canSubmitForm) {
				// --> remove warning:
				$('.product-flyout-notice--valuenotok').removeClass('js-visible');
				// --> show loaders:
				$('html').addClass('js-boxedloader-loading');
				$('.js-ajax-boxed-loader').removeAttr('hidden');
				// --> submit form:
				setTimeout(function(){
					$('#table-add-to-cart-form').submit();
				}, 200);
			} else {
				// --> show warning:
				$('.product-flyout-notice--valuenotok').addClass('js-visible');
			}
		});

		/* number spinner */
		/* ************** */

		/* note: this uses html that is added via JS in the "add to cart" block above */

		const $flyout_warningNotice = $('.product-flyout-notice--valuenotok');
		const $flyout_submit = $('.path-product .table-add-to-cart-form .form-submit');
		const $flyout_submit_default_text = $flyout_submit.val();
		$('.path-product .table-add-to-cart-form .form-number').each(function(index, element) {
			new duo.NumberSpinner({
				inputElement: $(element),
				checkForZero: true,
				onValueChange: function(currentNumber) {
					if(currentNumber > 0) {
						if($flyout_warningNotice.length > 0) {
							if($flyout_warningNotice.hasClass('js-visible')) {
								$flyout_warningNotice.removeClass('js-visible');
							}
						}
					}
					let total_quantity = 0;
					$('.path-product .table-add-to-cart-form .form-number').each(function(index, element){
						total_quantity += parseInt($(element).val(),10);
					});
					$flyout_submit.val(total_quantity === 0 ? $flyout_submit_default_text : Drupal.formatPlural(total_quantity, 'Add @count product to basket', 'Add @count products to basket'));
		 		},
			});
		});

	} /* setupFlyout */



/** --------------------------------------------------
    #helper functions
    -------------------------------------------------- */

	function isProductDetailPage() {
		let isProductDetail = false;

		if($('body').hasClass('path-product')) {
			isProductDetail = true;
		}

		return isProductDetail;
	} /* isProductDetailPage */
	
	
	
})(jQuery);
